import React, { useState, useRef, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import SelectBox1 from '../../../Components/Select1';
import Button from '../../../Components/Button';
import SelectBox from '../../../Components/Select';
import ConfirmationModal from '../../../Components/Modal/confirmModal';
import { jwtDecode } from 'jwt-decode';
import axios from 'axios';
import { GlobalContext } from '../../../GlobalContext';

import { toast } from 'react-toastify';

const ProductList = () => {
    const navigate = useNavigate();
    const { currentTab, setCurrentTab } = useContext(GlobalContext);

    useEffect(() => {
        setCurrentTab('Manage Products');
    });
    const token = localStorage.getItem('token');
    const decodedToken = jwtDecode(token);

    //--------------mouse drage(resize width)--------------
    const containerRef = useRef(null);
    const [columnWidths, setColumnWidths] = useState([]);
    const [isResizing, setIsResizing] = useState(false);
    const [startX, setStartX] = useState(0);
    const [currentColumnIndex, setCurrentColumnIndex] = useState(null);
    const numberOfColumns = 7; // Adjust this based on your actual number of columns

    useEffect(() => {
        const containerWidth = containerRef.current ? containerRef.current.clientWidth : 0;
        const initialWidth = containerWidth / numberOfColumns; // Divide the container width by the number of columns
        setColumnWidths(Array(numberOfColumns).fill(initialWidth)); // Set initial widths
    }, []);

    const handleMouseDown = (e, index) => {
        e.preventDefault(); // Prevent default behavior
        setIsResizing(true);
        setStartX(e.clientX);
        setCurrentColumnIndex(index);
    };

    const handleMouseMove = (e) => {
        if (isResizing && currentColumnIndex !== null) {
            const newWidths = [...columnWidths];
            const newWidth = newWidths[currentColumnIndex] + (e.clientX - startX);
            newWidths[currentColumnIndex] = Math.max(newWidth, 50); // Prevent column from being too small

            // Calculate total width of columns
            const totalWidth = newWidths.reduce((acc, width) => acc + width, 0);
            const containerWidth = containerRef.current.clientWidth; // Get the container width

            // If total width exceeds container width, adjust the widths proportionally
            if (totalWidth > containerWidth) {
                const excessWidth = totalWidth - containerWidth;
                const adjustment = excessWidth / (newWidths.length - 1); // Adjust all but the resized column

                newWidths.forEach((_, idx) => {
                    if (idx !== currentColumnIndex) {
                        newWidths[idx] = Math.max(newWidths[idx] - adjustment, 50); // Prevent columns from being too small
                    }
                });
            }

            setColumnWidths(newWidths);
            setStartX(e.clientX);
        }
    };

    const handleMouseUp = () => {
        setIsResizing(false);
        setCurrentColumnIndex(null);
    };

    useEffect(() => {
        if (isResizing) {
            window.addEventListener('mousemove', handleMouseMove);
            window.addEventListener('mouseup', handleMouseUp);
        }

        return () => {
            window.removeEventListener('mousemove', handleMouseMove);
            window.removeEventListener('mouseup', handleMouseUp);
        };
    }, [isResizing, currentColumnIndex]);

    const headArray = ['Product Name', 'Price(€)', 'Stock', 'Category', 'Brand', 'Purchase From','Operation'];

    const selectPageArray = ['20/page', '40/page', '60/page', '80/page'];

    const [productData, setProductData] = useState([]);

    useEffect(() => {
        const fetch = async () => {
            const POCBaseUrl = process.env.REACT_APP_GXIN_POC_BASE_URL;

            if (!POCBaseUrl) {
                throw new Error('API base URL is not defined');
            }

            await axios.post(`${POCBaseUrl}/products/get`,
                {
                    headers: {
                        "Content-Type": "application/json", // Specify content type
                        Authorization: `Bearer ${token}`, // Include the token
                    },
                }
            )
                .then(response => {
                    // console.log('agentData', response.data.data);
                    setProductData(response.data.data);
                })
                .catch(error => {
                    console.error("There was an error fetching the customer data!", error);
                });
        }
        fetch();
    }, []);

    const [searchProductKey, setSearchProductKey] = useState({'category':'','brand':''});
    const handleDataFromChild1 = (data) => {
        setSearchProductKey({
            ...searchProductKey,
            ['category']: data,
        });
    };
    const handleDataFromChild2 = (data) => {
        setSearchProductKey({
            ...searchProductKey,
            ['brand']: data,
        });
    };
    const searchProduct = async () => {
        const POCBaseUrl = process.env.REACT_APP_GXIN_POC_BASE_URL;

        if (!POCBaseUrl) {
            throw new Error('API base URL is not defined');
        }
        const searchValue = { searchKey: searchProductKey };
        await axios.post(`${POCBaseUrl}/products/searchproduct`, { searchValue },
            {
                headers: {
                    "Content-Type": "application/json", // Specify content type
                    Authorization: `Bearer ${token}`, // Include the token
                },
            }
        )
        .then(response => {
            console.log('searchagentData', response.data.data);
            setProductData(response.data.data);
        })
        .catch(error => {
            console.error("There was an error fetching the customer data!", error);
        });
    }

    const handleEditProductClick = (productId) => {
        navigate(`/editproduct/${productId}`); // Use navigate for routing
    };

    const [deleteConfirm, setDeleteConfirm] = useState(false);
    const [productIdToDelete, setProductIdToDelete] = useState(null);

    const handleProductDelete = (productId) => {
        setProductIdToDelete(productId);
        setDeleteConfirm(true);
    };
    const confirmDelete = async () => {

        try {
            const POCBaseUrl = process.env.REACT_APP_GXIN_POC_BASE_URL;

            if (!POCBaseUrl) {
                throw new Error('API base URL is not defined');
            }
            const productId = productIdToDelete;
            const response = await axios.post(`${POCBaseUrl}/products/deleteproduct`, { productId },
                {
                    headers: {
                        "Content-Type": "application/json", // Specify content type
                        Authorization: `Bearer ${token}`, // Include the token
                    },
                }
            )
                .then(response => {
                    setProductData(response.data.data);
                })
                .catch(error => {
                    console.error("There was an error", error);
                })
        } catch (error) {
            console.error('Error sending message:', error);
        }
        setDeleteConfirm(false);
        setProductIdToDelete(null);
    };

    //-----------------add stock-----------------
    const [addstockConfirm, setAddStockConfirm] = useState(false);
    const [productIdToAddStock, setProductIdToAddStock] = useState(null);
    const [addStockProduct, setAddStockProduct] = useState({});
    const [stock, setStock] = useState(0);

    const handleProductAddStock = (productId) => {
        setProductIdToAddStock(productId);
        setAddStockConfirm(true);
        console.log(productData,productId);
        const filteredProducts = productData.filter(item => item._id === productId);
        setAddStockProduct(filteredProducts[0]);
    };

    const AddStock = async () => {

        try {
            const POCBaseUrl = process.env.REACT_APP_GXIN_POC_BASE_URL;

            if (!POCBaseUrl) {
                throw new Error('API base URL is not defined');
            }
            const productId = productIdToAddStock;
            const response = await axios.post(`${POCBaseUrl}/products/addstock`, { productId, stock },
                {
                    headers: {
                        "Content-Type": "application/json", // Specify content type
                        Authorization: `Bearer ${token}`, // Include the token
                    },
                }
            )
                .then(response => {
                    toast.success("Stock updated successfully!", {
                        className: 'centered-toast-success',
                        bodyClassName: 'centered-body',
                        autoClose: 2000,
                        hideProgressBar: true,
                        closeButton: false,
                        pauseOnHover: false,
                        draggable: true,
                      });
                    setProductData(response.data.data);
                })
                .catch(error => {
                    console.error("There was an error", error);
                })
        } catch (error) {
            console.error('Error sending message:', error);
        }
        setAddStockConfirm(false);
        setProductIdToAddStock(null);
    };
    //-------------pagination--------------------
    const [currentPage, setCurrentPage] = useState(1);

    const [rowsPerPage, setRowsPerPage] = useState(20);
    const indexOfLastRow = currentPage * rowsPerPage;
    const indexOfFirstRow = indexOfLastRow - rowsPerPage;
    const currentRows = productData.slice(indexOfFirstRow, indexOfLastRow);
    const totalPages = Math.ceil(productData.length / rowsPerPage);

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    const handleRowPage = (data) => {
        if (data === '20/page') {
            setRowsPerPage(20);
        }
        if (data === '40/page') {
            setRowsPerPage(40);
        }
        if (data === '60/page') {
            setRowsPerPage(60);
        }
        if (data === '80/page') {
            setRowsPerPage(80);
        }
    }

    // fetch brand category
    const [brandList, setBrandList] = useState([]);
    const [categoryList, setCategoryList] = useState([]);
    const fetchBrand = async() => {
        try {
            const POCBaseUrl = process.env.REACT_APP_GXIN_POC_BASE_URL;

            if (!POCBaseUrl) {
                throw new Error('API base URL is not defined');
            }
            const response = await axios.post(`${POCBaseUrl}/products/get/brand`,
                {
                    headers: {
                      "Content-Type": "application/json", // Specify content type
                      Authorization: `Bearer ${token}`, // Include the token
                    },
                  }
            )
            .then(response=>{
                // console.log(response.data.message);
                const brandNames = response.data.data.map(brand => brand.brand_name);
                brandNames.unshift('Select Brand');
                setBrandList(brandNames);
            })
            .catch(error=>{
                console.error("There was an error", error);
            })
        } catch (error) {
            console.error('Error sending message:', error);
        }
    }

    const fetchCategory = async() => {
        try {
            const POCBaseUrl = process.env.REACT_APP_GXIN_POC_BASE_URL;

            if (!POCBaseUrl) {
                throw new Error('API base URL is not defined');
            }
            const response = await axios.post(`${POCBaseUrl}/products/get/category`,
                {
                    headers: {
                      "Content-Type": "application/json", // Specify content type
                      Authorization: `Bearer ${token}`, // Include the token
                    },
                  }
            )
            .then(response=>{
                // console.log(response.data.message);
                const categoryNames = response.data.data.map(category => category.category_name);
                categoryNames.unshift('Select Category');
                setCategoryList(categoryNames);
            })
            .catch(error=>{
                console.error("There was an error", error);
            })
        } catch (error) {
            console.error('Error sending message:', error);
        }
    }
    
    useEffect(()=> {
        fetchBrand();
        fetchCategory();
    },[])

    return (
        <div className='h-full list-table-scroll'>
            <div className='w-full flex justify-between items-center bg-[#f0f0f0] my-2.5 p-2.5' style={{ fontFamily: 'Liberation Serif' }}>
                <div></div>
                <div className='flex items-center'>
                    <span className='mr-[5px] text-[14px] text-[#5a5655]'>Category:</span>
                    <SelectBox1 name={'category'} value={searchProductKey.category || ''} onSendData={handleDataFromChild1} placeholder={'please select Category'} options={categoryList} />
                    <span className='mr-[5px] text-[14px] text-[#5a5655] ml-3'>Brand:</span>
                    <SelectBox1 name={'brand'} value={searchProductKey.brand || ''} onSendData={handleDataFromChild2} placeholder={'please select Brand'} options={brandList} />
                    <div>&nbsp;</div>
                    <Button children={'Search'} onClick={searchProduct} />
                </div>
            </div>
            <div className='w-full h-[calc(100%-180px)] border-r-0 border-b-0 bg-[#f0f0f0] overflow-auto' ref={containerRef}>
                <table className='table-fixed border-collapse border border-[#ebeef5]'>
                    <thead className='text-[#909399] font-medium'>
                        <tr className='bg-[#fafafa]' style={{ fontFamily: 'SimSun' }}>
                            {columnWidths.map((width, index) => (
                                <th key={index} style={{ width }} className='border-collapse border border-[#ebeef5] select-none bg-white py-3 min-w-0 truncate align-middle relative text-left text-sm font-normal'>
                                    <div onMouseDown={(e) => handleMouseDown(e, index)} className='cursor-col-resize text-center text-black font-bold break-words leading-[27px] pl-2.5 inline-block relative align-middle pr-2.5 w-full truncate whitespace-normal' style={{ fontFamily: 'Liberation Serif' }}>
                                        {headArray[index]}
                                    </div>
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {(productData && productData.length > 0) && productData.map((product, Index) => (
                            <tr key={Index} className='bg-[#fafafa]'>
                                <td className='border-collapse border border-[#ebeef5] select-none bg-white py-2 min-w-0 truncate align-middle relative text-left text-center text-[13px] font-normal'>
                                    {product.name || ''}
                                </td>
                                <td className='border-collapse border border-[#ebeef5] select-none bg-white py-2 min-w-0 truncate align-middle relative text-left text-center text-[13px] font-normal'>
                                    {product.price || ''}
                                </td>
                                <td className='border-collapse border border-[#ebeef5] select-none bg-white py-2 min-w-0 truncate align-middle relative text-left text-center text-[13px] font-normal'>
                                    {product.stock || ''}
                                </td>
                                <td className='border-collapse border border-[#ebeef5] select-none bg-white py-2 min-w-0 truncate align-middle relative text-left text-center text-[13px] font-normal'>
                                    {product.category || ''}
                                </td>
                                <td className='border-collapse border border-[#ebeef5] select-none bg-white py-2 min-w-0 truncate align-middle relative text-left text-center text-[13px] font-normal'>
                                    {product.brand || ''}
                                </td>
                                <td className='border-collapse border border-[#ebeef5] select-none bg-white py-2 min-w-0 truncate align-middle relative text-left text-center text-[13px] font-normal'>
                                    {product.seller || ''}
                                </td>
                                <td className='border-collapse border border-[#ebeef5] select-none bg-white py-2 min-w-0 truncate align-middle relative text-left text-center text-[13px] font-normal'>
                                    <div className="text-center box-border overflow-hidden text-ellipsis whitespace-normal break-all leading-[23px] px-[10px]">
                                        <span onClick={() => handleProductAddStock(product._id)} className='cursor-pointer text-[#2776c3] whitespace-nowrap'>Add stock / </span>
                                        <span onClick={() => handleEditProductClick(product._id)} className='cursor-pointer text-[#2776c3] whitespace-nowrap'>Edit / </span>
                                        <span onClick={() => handleProductDelete(product._id)} className='cursor-pointer text-[#2776c3] whitespace-nowrap'>Delete</span>
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            <div className='flex items-center mt-[12px]' style={{ fontFamily: 'Liberation Serif' }}>
                <div className='flex whitespace-nowrap text-[#303133] font-bold'>
                    <span className='inline-block text-[13px] min-w-[35.5px] h-[28px] leading-[28px] align-top mr-2.5 font-normal text-[#606266]'>totally 0 item</span>
                    <div className="flex justify-center items-center">
                        <button
                            onClick={() => handlePageChange(currentPage - 1)}
                            disabled={currentPage === 1}
                            className="w-[30px] h-[28px] bg-[#f4f4f5] rounded-sm hover:cursor-pointer disabled:cursor-not-allowed mr-2 group pl-2"
                        >
                            <svg
                                className="w-3 fill-[#606266] group-disabled:fill-gray-300"
                                viewBox="0 0 55.753 55.753"
                            >
                                <path
                                    d="M12.745 23.915c.283-.282.59-.52.913-.727L35.266 1.581a5.4 5.4 0 0 1 7.637 7.638L24.294 27.828l18.705 18.706a5.4 5.4 0 0 1-7.636 7.637L13.658 32.464a5.367 5.367 0 0 1-.913-.727 5.367 5.367 0 0 1-1.572-3.911 5.369 5.369 0 0 1 1.572-3.911z"
                                    data-original="#000000"
                                />
                            </svg>
                        </button>

                        <div className="flex space-x-2">
                            {[...Array(totalPages).keys()].map((number) => (
                                <button
                                    key={number}
                                    onClick={() => handlePageChange(number + 1)}
                                    className={`w-[30px] h-[28px] rounded-sm text-sm font-medium ${currentPage === number + 1
                                        ? 'bg-blue-600 text-white'
                                        : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
                                        }`}
                                >
                                    {number + 1}
                                </button>
                            ))}
                        </div>

                        <button
                            onClick={() => handlePageChange(currentPage + 1)}
                            disabled={currentPage === totalPages}
                            className="w-[30px] h-[28px] bg-[#f4f4f5] rounded-sm hover:cursor-pointer disabled:cursor-not-allowed ml-3 items-center group pl-2"
                        >
                            <svg
                                className="w-3 fill-[#606266] group-disabled:fill-gray-300 rotate-180"
                                viewBox="0 0 55.753 55.753"
                            >
                                <path
                                    d="M12.745 23.915c.283-.282.59-.52.913-.727L35.266 1.581a5.4 5.4 0 0 1 7.637 7.638L24.294 27.828l18.705 18.706a5.4 5.4 0 0 1-7.636 7.637L13.658 32.464a5.367 5.367 0 0 1-.913-.727 5.367 5.367 0 0 1-1.572-3.911 5.369 5.369 0 0 1 1.572-3.911z"
                                    data-original="#000000"
                                />
                            </svg>
                        </button>
                    </div>
                    <span className='inline-block text-[13px] min-w-[35.5px] h-[28px] leading-[28px] align-top font-normal text-[#606266] ml-[5px]'>
                        Go to
                        <div className='w-[50px] inline-block ml-[5px]'>
                            <input
                                type="text"
                                placeholder="1"
                                className="h-[28px] px-1 text-[14px] rounded-md bg-white border border-[#dcdfe6] w-full outline-blue-500 text-center"
                                value={currentPage}
                                onChange={(e) => setCurrentPage(e.target.value)}
                            />
                        </div>
                    </span>
                    <Button children={'Confirm'} className={'!h-[28px] !py-1 !w-[60px] !px-0 ml-[5px]'} />
                    <SelectBox options={selectPageArray} onSendData={handleRowPage} value={'20/page'} className={'!w-[100px] !h-[28px]'} />
                </div>
            </div>
            <ConfirmationModal title={'Are you sure you want to delete this product?'}  isOpen={deleteConfirm} onClose={() => setDeleteConfirm(false)}  onConfirm={confirmDelete}/>
            {addstockConfirm && (
                <div className="fixed inset-0 p-2 flex flex-wrap justify-center items-center w-full h-full z-[1000] before:fixed before:inset-0 before:w-full before:h-full before:bg-[rgba(0,0,0,0.5)] overflow-auto font-[sans-serif]" style={{ fontFamily: 'Liberation Serif' }}>
                    <div className="w-[500px] bg-white shadow-lg rounded-lg p-2 relative">
                        <div className="flex items-center p-5 border-b border-gray-300">
                            <h3 className="text-xl flex-1 text-center text-[#2776c3]">Add Product Stock</h3>
                            <svg
                                className="w-3 ml-2 cursor-pointer shrink-0 fill-gray-400 hover:fill-red-500"
                                viewBox="0 0 320.591 320.591"
                                onClick={() => setAddStockConfirm(false)} // Close modal on click
                            >
                                <path
                                    d="M30.391 318.583a30.37 30.37 0 0 1-21.56-7.288c-11.774-11.844-11.774-30.973 0-42.817L266.643 10.665c12.246-11.459 31.462-10.822 42.921 1.424 10.362 11.074 10.966 28.095 1.414 39.875L51.647 311.295a30.366 30.366 0 0 1-21.256 7.288z"
                                />
                                <path
                                    d="M287.9 318.583a30.37 30.37 0 0 1-21.257-8.806L8.83 51.963C-2.078 39.225-.595 20.055 12.143 9.146c11.369-9.736 28.136-9.736 39.504 0l259.331 257.813c12.243 11.462 12.876 30.679 1.414 42.922-.456.487-.927.958-1.414 1.414a30.368 30.368 0 0 1-23.078 7.288z"
                                />
                            </svg>
                        </div>

                        <div className='text-[14px]'>
                            <div className='flex flex-row items-center m-[20px]'>
                                <span className='w-[110px] text-[#5a5655] text-[14px]'>Product Name:</span>
                                <div className='flex-1 ml-[5px] relative text-[14px] inline-block w-full'>
                                    <input
                                        type="text"
                                        disabled
                                        autoComplete="off"
                                        placeholder={addStockProduct.name}
                                        className="p-0 pl-[15px] w-[350px] h-[40px] text-[#606266] bg-[#f5f7fa] border border-[#e4e7ed] rounded-sm"
                                    />
                                </div>
                            </div>
                            <div className='flex flex-row items-center m-[20px]'>
                                <span className='w-[110px] text-[#5a5655] text-[14px]'>Category:</span>
                                <div className='flex-1 ml-[5px] relative text-[14px] inline-block w-full'>
                                    <input
                                        type="text"
                                        disabled
                                        autoComplete="off"
                                        placeholder={addStockProduct.category}
                                        className="p-0 pl-[15px] w-[350px] h-[40px] text-[#606266] bg-[#f5f7fa] border border-[#e4e7ed] rounded-sm"
                                    />
                                </div>
                            </div>
                            <div className='flex flex-row items-center m-[20px]'>
                                <span className='w-[110px] text-[#5a5655] text-[14px]'>Brand Name:</span>
                                <div className='flex-1 ml-[5px] relative text-[14px] inline-block w-full'>
                                    <input
                                        type="text"
                                        disabled
                                        autoComplete="off"
                                        placeholder={addStockProduct.brand}
                                        className="p-0 pl-[15px] w-[350px] h-[40px] text-[#606266] bg-[#f5f7fa] border border-[#e4e7ed] rounded-sm"
                                    />
                                </div>
                            </div>
                            <div className='flex flex-row items-center m-[20px]'>
                                <span className='w-[110px] text-[#5a5655] text-[14px]'>Stock:</span>
                                <div className='flex-1 ml-[5px] relative text-[14px] inline-block w-full'>
                                    <input
                                        type="number"
                                        autoComplete="off"
                                        placeholder="Please Input the Stock Count"
                                        className="p-0 pl-[15px] w-[350px] h-[40px] text-[#606266] leading-[40px] bg-[#fff] border border-[#e4e7ed] rounded-sm outline-none"
                                        onChange={(e) => setStock(e.target.value)}
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="pt-10 flex justify-center gap-4 mb-3" style={{ fontFamily: 'Liberation Serif' }}>
                            <button
                                type="button"
                                className="w-[300px] h-[36px] rounded-md text-[white] text-sm border-none outline-none tracking-wide bg-[#2776c3]"
                                onClick={AddStock}
                            >
                                ADD
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}
export default ProductList;